export default {
  logs: `/mobile/mobiles/logs`
};
